import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon_close_line.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-e6cb0788")

_pushScopeId("data-v-e6cb0788")
const _hoisted_1 = { class: "fridgedetailsmyassistlistitem-title-text" }
const _hoisted_2 = { class: "fridgedetailsmyassistlistitem-mode" }
const _hoisted_3 = { class: "fridgedetailsmyassistlistitem-mode-block" }
const _hoisted_4 = { class: "fridgedetailsmyassistlistitem-mode-block-text" }
const _hoisted_5 = { class: "fridgedetailsmyassistlistitem-time" }
const _hoisted_6 = { class: "fridgedetailsmyassistlistitem-time-block" }
const _hoisted_7 = { class: "fridgedetailsmyassistlistitem-time-block-text" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "fridgedetailsmyassistlistitem-delete-image" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "fridgedetailsmyassistlistitem-delete-image-image",
    src: _imports_0
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "fridgedetailsmyassistlistitem",
    style: _ctx.stylePaddingRight,
    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickItem(...args)))
  }, [
    _createVNode("div", {
      class: "fridgedetailsmyassistlistitem-title",
      style: _ctx.styleTitle
    }, [
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.name), 1)
    ], 4),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.mode), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.settingTime), 1)
      ])
    ]),
    (_ctx.isEditMode)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "fridgedetailsmyassistlistitem-delete",
          onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteTouchStart(...args))),
          onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteTouchMove(...args))),
          onTouchcancel: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteTouchCancel(...args))),
          onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteTouchEnd(...args))),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickItemDelete(...args)))
        }, [
          _hoisted_8
        ], 32))
      : _createCommentVNode("", true)
  ], 4))
})